import { FC, useState, useEffect } from "react";
import axios, { AxiosResponse } from "axios";
import queryString from "query-string";
import ReactNotification from "react-notifications-component";
import Loader from "../../UI/CustomLoader";
import Header from "../../sections/Header";
import Breadcrumbs from "../../UI/Breadcrumbs";
import ManageBranding from "../../sections/Manage-branding/ManageBranding";
import CompanyListSelector from "../../sections/CompanyList/CompanyListSelector";
import { breadcrumbs, initialCompanyDetails } from "./successPay.const";
import {
  FULL_COMPANY_DETAILS,
  MASTER_DETAILS
} from "../../../utils/api.config.consts";
import { CompanyDetails } from "../../../entities/SuccessPay";
import ReactNotificationMessenger, {
  ERROR,
  FETCH_ERROR,
  DANGER
} from "../../../utils/ReactNotification.config";
import { base_url, api } from "../../../utils/env";

import "../../css/EnableSuccessPay.css";

import GoogleAnalyticsConfiguration from "../../../googleAnalytics/googleAnalyticsConfiguration";
import { PaymentAccount } from "./index";
import { useLocation } from "react-router-dom";

const SuccessPay: FC = () => {

    const [selectCompanyID, setSelectCompanyID] = useState<string | null>("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<CompanyDetails>(initialCompanyDetails);
    const [masterID, setMasterID] = useState<string | null>(
        queryString.parse(`?masterID=${localStorage.getItem("masterID")}`).masterID as string | null
    );
    const companySelected = localStorage.getItem("swpayCompanySelected");

    useLocation();

    useEffect(() => {
        if (companySelected !== "default") {
            setSelectCompanyID(companySelected);
        }
    }, [selectCompanyID]);

    useEffect(() => {
        GoogleAnalyticsConfiguration.sendPageView("Successpay Company Setup");
        if (selectCompanyID && selectCompanyID !== "default") {
            setLoading(true);
            getCompanyDetails();
        }
    }, [selectCompanyID]);

    const getCompanyDetails = () => {
        axios.get(`${base_url}${api}/${FULL_COMPANY_DETAILS}/${selectCompanyID}/${MASTER_DETAILS}/${masterID}`)
            .then((response: AxiosResponse<any>) => {
                setLoading(false);
                setData(
                    {
                        ...initialCompanyDetails,
                        ...response.data
                    }
                );
            })
            .catch(() => {
                setLoading(false);
                ReactNotificationMessenger.showNotification(ERROR, FETCH_ERROR, DANGER);
                setData(initialCompanyDetails);
            });
    }

    const onCompanyChange = (companyID: string) => {
        setData({} as CompanyDetails);
        setSelectCompanyID(companyID);
        localStorage.setItem("swpayCompanySelected", companyID);
    }

    return (
        <>
            <ReactNotification />
            <Header />
            <Breadcrumbs details={breadcrumbs} />
            <Loader showLoader={loading} />
            <CompanyListSelector selectCompanyID={onCompanyChange} setLoading={setLoading} masterID={masterID} companyID={selectCompanyID} />
            <ManageBranding companyID={selectCompanyID} setLoading={setLoading} data={data.companyDetail} masterId={masterID} selectCompanyID={onCompanyChange} />
            <PaymentAccount companyId={selectCompanyID} masterId={masterID} data={data}/>
        </>
    );
};

export default SuccessPay;
